// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1274":"d4cff3c9","2679":"22cf7486","3322":"d4cff3c9","5890":"6143e773","6618":"7d729602"}[chunkId] + ".chunk.css";
};